export const icons = {
    'Cloud': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M18.456 10.45a6.45 6.45 0 0 0 -12 -2.151a4.857 4.857 0 0 0 -4.44 5.241a4.856 4.856 0 0 0 5.236 4.444h10.751a3.771 3.771 0 0 0 3.99 -3.54a3.772 3.772 0 0 0 -3.538 -3.992z"></path>
    `,
    'OR': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M10.831 20.413l-5.375 -6.91c-.608 -.783 -.608 -2.223 0 -3l5.375 -6.911a1.457 1.457 0 0 1 2.338 0l5.375 6.91c.608 .783 .608 2.223 0 3l-5.375 6.911a1.457 1.457 0 0 1 -2.338 0z"></path>
    `,
    'AB': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 16v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"></path>
        <path d="M12 6l0 12"></path>
        <path d="M16 16v-8h3a2 2 0 0 1 0 4h-3m3 0a2 2 0 0 1 0 4h-3"></path>
    `,
    'JS': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"></path>
        <path d="M7.5 8h3v8l-2 -1"></path>
        <path d="M16.5 8h-2.5a.5 .5 0 0 0 -.5 .5v3a.5 .5 0 0 0 .5 .5h1.423a.5 .5 0 0 1 .495 .57l-.418 2.93l-2 .5"></path>
    `,
    'Robot': ` 
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"></path>
        <path d="M9.5 15a3.5 3.5 0 0 0 5 0"></path>
        <path d="M15 11l.01 0"></path>
        <path d="M9 11l.01 0"></path>
    `,
    'AI': `
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z" />
    `,
    'Edit': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7.904 17.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l4.907 4.907a1.067 1.067 0 0 0 1.509 0l1.047 -1.047a1.067 1.067 0 0 0 0 -1.509l-4.907 -4.907l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563z"></path>
    `,
    'Devives': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M13 9a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-10z"></path>
        <path d="M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"></path>
        <path d="M16 9h2"></path>
    `,
    'DevicesAdd': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M13 16.5v-7.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3.5"></path>
        <path d="M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8"></path>
        <path d="M16 9h2"></path>
        <path d="M16 19h6"></path>
        <path d="M19 16v6"></path>
    `,
    'DeviceMobile': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M6 5a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-14z"></path>
        <path d="M11 4h2"></path>
        <path d="M12 17v.01"></path>
    `,
    'DeviceTablet': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 6a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-12z"></path>
        <path d="M9 17h6"></path>
    `,
    'DeviceDesktop': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 5a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10z"></path>
        <path d="M7 20h10"></path>
        <path d="M9 16v4"></path>
        <path d="M15 16v4"></path>
    `,
    'Component': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 12l3 3l3 -3l-3 -3z"></path>
        <path d="M15 12l3 3l3 -3l-3 -3z"></path>
        <path d="M9 6l3 3l3 -3l-3 -3z"></path>
        <path d="M9 18l3 3l3 -3l-3 -3z"></path>
    `,
    'ComponentRoot': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 12l3 3l3 -3l-3 -3z" fill="currentColor"></path>
        <path d="M15 12l3 3l3 -3l-3 -3z" fill="currentColor"></path>
        <path d="M9 6l3 3l3 -3l-3 -3z" fill="currentColor"></path>
        <path d="M9 18l3 3l3 -3l-3 -3z" fill="currentColor"></path>
    `,
    'AddWidget': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
        <path d="M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
        <path d="M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
        <path d="M14 7l6 0"></path>
        <path d="M17 4l0 6"></path>
   `,
    'ComponentUpdate': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M10.09 4.01l.496 -.495a2 2 0 0 1 2.828 0l7.071 7.07a2 2 0 0 1 0 2.83l-7.07 7.07a2 2 0 0 1 -2.83 0l-7.07 -7.07a2 2 0 0 1 0 -2.83l3.535 -3.535h-3.988"></path>
        <path d="M7.05 11.038v-3.988"></path>
    `,

    'ComponentUnlink': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M17 22v-2"></path>
        <path d="M9 15l6 -6"></path>
        <path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464"></path>
        <path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463"></path>
        <path d="M20 17h2"></path>
        <path d="M2 7h2"></path>
        <path d="M7 2v2"></path>
    `,

    'CreateBasic': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7"></path>
        <path d="M16 19h6"></path>
        <path d="M19 16v6"></path>
        <path d="M11 4h2"></path>
        <path d="M12 17v.01"></path>
    `,
    'GridContainer': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
        <path d="M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
        <path d="M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
        <path d="M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
    `,
    'FlexContainerRow': `
        <g transform="rotate(90 12 12)">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -2" />
            <path d="M4 16a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -2" />
        </g>
    `,
    'FlexContainerCol': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -2" />
        <path d="M4 16a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -2" />
    `,
    'FlexContainerStretch': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M16 4l4 0l0 4" />
        <path d="M14 10l6 -6" />
        <path d="M8 20l-4 0l0 -4" />
        <path d="M4 20l6 -6" />
        <path d="M16 20l4 0l0 -4" />
        <path d="M14 14l6 6" />
        <path d="M8 4l-4 0l0 4" />
        <path d="M4 4l6 6" />
    `,
    'FlexGrowWidth': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6" />
        <path d="M10 18h-7" />
        <path d="M21 18h-7" />
        <path d="M6 15l-3 3l3 3" />
        <path d="M18 15l3 3l-3 3" />
    `,
    'FlexGrowHeight': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h6" />
        <path d="M18 14v7" />
        <path d="M18 3v7" />
        <path d="M15 18l3 3l3 -3" />
        <path d="M15 6l3 -3l3 3" />
    `,
    'Text': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M6 4l12 0"></path>
        <path d="M12 4l0 16"></path>
    `,
    'BoxPlus': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M13 16h-7a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v1" />
        <path d="M16 18h6" />
        <path d="M19 15v6" />
    `,
    'BoxWide': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>
    `,
    'BoxLong': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"></path>
    `,
    'VectorFreeHand': `
        <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
        <path d="M13.5 6.5l4 4" />
    `,
    'VectorFreehand2': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M4 15c2 -4.97 7.356 -11 9 -11c4.25 0 -5.5 11.958 -3 13s5.65 -6.678 7.4 -5.902c1.75 .777 -1.05 7.589 -.3 8.63s3.15 -.897 3.9 -2.728" />
    `,
    'VectorBezier': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"></path>
        <path d="M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"></path>
        <path d="M17 5c-6.627 0 -12 5.373 -12 12"></path>
    `,
    'VectorTriangle': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M10 4m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"></path>
        <path d="M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"></path>
        <path d="M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"></path>
        <path d="M6.5 17.1l5 -9.1"></path>
        <path d="M17.5 17.1l-5 -9.1"></path>
        <path d="M7 19l10 0"></path>
    `,
    'VectorRectangle': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"></path>
        <path d="M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"></path>
        <path d="M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"></path>
        <path d="M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"></path>
        <path d="M5 7l0 10"></path>
        <path d="M19 7l0 10"></path>
        <path d="M7 5l10 0"></path>
        <path d="M7 19l10 0"></path>
    `,
    'VectorBezier2': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"></path>
        <path d="M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"></path>
        <path d="M7 5l7 0"></path>
        <path d="M10 19l7 0"></path>
        <path d="M9 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M15 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M7 5.5a5 6.5 0 0 1 5 6.5a5 6.5 0 0 0 5 6.5"></path>
    `,
    'VectorPath': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
        <path d="M9 15v6"></path>
        <path d="M11.5 9.5l6.5 -6.5"></path>
    `,
    'VectorCircle': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 11a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -2" />
        <path d="M17 11a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -2" />
        <path d="M10 4a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -2" />
        <path d="M10 18a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -2" />
        <path d="M19 10a5 5 0 0 0 -5 -5" /><path d="M19 14a5 5 0 0 1 -5 5" />
        <path d="M5 14a5 5 0 0 0 5 5" />
        <path d="M5 10a5 5 0 0 1 5 -5" />
    `,
    'VectorDiamond': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M10.831 20.413l-5.375 -6.91c-.608 -.783 -.608 -2.223 0 -3l5.375 -6.911a1.457 1.457 0 0 1 2.338 0l5.375 6.91c.608 .783 .608 2.223 0 3l-5.375 6.911a1.457 1.457 0 0 1 -2.338 0" />
    `,
    'VectorDiamond2': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <g transform="translate(12 12) scale(0.85) rotate(45) translate(-12 -12)"><path d="M3 4a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -2" />
        <path d="M17 4a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -2" />
        <path d="M17 18a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -2" />
        <path d="M3 18a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -2" />
        <path d="M5 7l0 10" />
        <path d="M19 7l0 10" />
        <path d="M7 5l10 0" />
        <path d="M7 19l10 0" /></g>
    `,
    'Play': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7 4v16l13 -8z"></path>
    `,
    'PlayVideo': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"></path>
        <path d="M3 6m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"></path>
    `,
    'Plus': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 5l0 14"></path>
        <path d="M5 12l14 0"></path>
    `,
    'PlusSquare': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M9 12h6" />
        <path d="M12 9v6" />
        <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z" />`,
    'HelpOutline': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
        <path d="M12 16v.01"></path>
        <path d="M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"></path>
    `,
    'Help': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 13a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z" stroke-width="0" fill="currentColor"></path>
    `,
    'Artboard': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M8 8m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"></path>
        <path d="M3 8l1 0"></path>
        <path d="M3 16l1 0"></path>
        <path d="M8 3l0 1"></path>
        <path d="M16 3l0 1"></path>
        <path d="M20 8l1 0"></path>
        <path d="M20 16l1 0"></path>
        <path d="M8 20l0 1"></path>
        <path d="M16 20l0 1"></path>
    `,
    'Hotspot': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7 19a2 2 0 0 1 -2 -2"></path>
        <path d="M5 13v-2"></path>
        <path d="M5 7a2 2 0 0 1 2 -2"></path>
        <path d="M11 5h2"></path>
        <path d="M17 5a2 2 0 0 1 2 2"></path>
        <path d="M19 11v2"></path>
        <path d="M19 17v4"></path>
        <path d="M21 19h-4"></path>
        <path d="M13 19h-2"></path>
    `,
    'Layer': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 6l-8 4l8 4l8 -4l-8 -4"></path>
        <path d="M4 14l8 4l8 -4"></path>
    `,
    'LayerTop': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7 9.5l-3 1.5l8 4l8 -4l-3 -1.5"></path>
        <path d="M4 15l8 4l8 -4"></path>
        <path d="M12 11v-7"></path>
        <path d="M9 7l3 -3l3 3"></path>
    `,
    'LayerUp': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7 9.5l-3 1.5l8 4l8 -4l-3 -1.5"></path>

        <path d="M12 11v-7"></path>
        <path d="M9 7l3 -3l3 3"></path>
    `,
    'LayerDown': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M6 10l-2 1l8 4l8 -4l-2 -1"></path>
 
        <path d="M12 4v7"></path>
        <path d="M15 8l-3 3l-3 -3"></path>
    `,
    'LayerBottom': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M6 10l-2 1l8 4l8 -4l-2 -1"></path>
        <path d="M4 15l8 4l8 -4"></path>
        <path d="M12 4v7"></path>
        <path d="M15 8l-3 3l-3 -3"></path>
    `,
    'Group': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2"></path>
    `,
    'UnGroup': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M8.59 4.581c.362 -.359 .86 -.581 1.41 -.581h8a2 2 0 0 1 2 2v8c0 .556 -.227 1.06 -.594 1.422m-3.406 .578h-6a2 2 0 0 1 -2 -2v-6"></path>
        <path d="M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2"></path>
        <path d="M3 3l18 18"></path>
    `,
    'Replicate': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 14h16v5a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-5z"></path>
        <path d="M4 9v.01"></path>
        <path d="M4 4v.01"></path>
        <path d="M9 4v.01"></path>
        <path d="M15 4v.01"></path>
        <path d="M20 4v.01"></path>
        <path d="M20 9v.01"></path>
    `,
    'Replicate2': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
        <path d="M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
        <path d="M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
        <path d="M14 17h6m-3 -3v6"></path>
    `,
    'Grid': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
        <path d="M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
        <path d="M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
        <path d="M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
    `,
    'NoGrid': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M4 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
        <path d="M4 13m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
        <path d="M14 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
        <path d="M14 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />`
    ,
    'Rows': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path>
        <path d="M4 12l16 0"></path>
    `,
    'Columns': `
        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
        <path d="M12 4l0 16" />
    `,
    'Distribute': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4l0 16"></path>
        <path d="M20 4l0 16"></path>
        <path d="M9 6m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
    `,
    'AlignMiddle': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 12l5 0"></path>
        <path d="M15 12l5 0"></path>
        <path d="M9 6m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
    `,
    'AlignCenter': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 4l0 5"></path>
        <path d="M12 15l0 5"></path>
        <path d="M6 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"></path>
    `,
    'AlignTop': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4l16 0"></path>
        <path d="M9 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
    `,
    'AlignBottom': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 20l16 0"></path>
        <path d="M9 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
    `,
    'AlignLeft': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4l0 16"></path>
        <path d="M8 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"></path>
    `,
    'AlignRight': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M20 4l0 16"></path>
        <path d="M4 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"></path>
    `,
    'AlignHorizontal': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4l16 0"></path>
        <path d="M4 20l16 0"></path>
        <path d="M6 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"></path>
    `,
    'AlignVertical': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4l0 16"></path>
        <path d="M20 4l0 16"></path>
        <path d="M9 6m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
    `,
    'AlignGrid': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M4 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
        <path d="M4 13m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
        <path d="M14 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
        <path d="M14 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
    `,
    'Settings': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
        <path d="M6 4v4"></path>
        <path d="M6 12v8"></path>
        <path d="M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
        <path d="M12 4v10"></path>
        <path d="M12 18v2"></path>
        <path d="M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
        <path d="M18 4v1"></path>
        <path d="M18 9v11"></path>
    `,
    'SettingsCog': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"></path>
        <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
    `,
    'SettingsBorder': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M4 20v-14a2 2 0 0 1 2 -2h14" />
        <path d="M20 8v.01" />
        <path d="M20 12v.01" />
        <path d="M20 16v.01" />
        <path d="M8 20v.01" />
        <path d="M12 20v.01" />
        <path d="M16 20v.01" />
        <path d="M20 20v.01" />
    `,
    'SettingsList': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"></path>
        <path d="M9 7l6 0"></path>
        <path d="M9 11l6 0"></path>
        <path d="M9 15l6 0"></path>
    `,
    'SettingsTree': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 6h11"></path>
        <path d="M12 12h8"></path>
        <path d="M15 18h5"></path>
        <path d="M5 6v.01"></path>
        <path d="M8 12v.01"></path>
        <path d="M11 18v.01"></path>
    `,
    'Comment': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 20l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c3.255 2.777 3.695 7.266 1.029 10.501c-2.666 3.235 -7.615 4.215 -11.574 2.293l-4.7 1"></path>
    `,
    'TextBold': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7 5h6a3.5 3.5 0 0 1 0 7h-6z"></path>
        <path d="M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7"></path>
    `,
    'TextItalic': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M11 5l6 0"></path>
        <path d="M7 19l6 0"></path>
        <path d="M14 5l-4 14"></path>
    `,
    'TextUnderline': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7 5v5a5 5 0 0 0 10 0v-5"></path>
        <path d="M5 19h14"></path>
    `,
    'TextStrike': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 12l14 0"></path>
        <path d="M16 6.5a4 2 0 0 0 -4 -1.5h-1a3.5 3.5 0 0 0 0 7h2a3.5 3.5 0 0 1 0 7h-1.5a4 2 0 0 1 -4 -1.5"></path>
    `,
    'TextSize': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 7v-2h13v2"></path>
        <path d="M10 5v14"></path>
        <path d="M12 19h-4"></path>
        <path d="M15 13v-1h6v1"></path>
        <path d="M18 12v7"></path>
        <path d="M17 19h2"></path>
    `,
    'TextAlignLeft': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 6l16 0"></path>
        <path d="M4 12l10 0"></path>
        <path d="M4 18l14 0"></path>
    `,
    'TextAlignRight': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 6l16 0"></path>
        <path d="M10 12l10 0"></path>
        <path d="M6 18l14 0"></path>
    `,
    'TextAlignCenter': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 6l16 0"></path>
        <path d="M8 12l8 0"></path>
        <path d="M6 18l12 0"></path>
    `,
    'TextAlignJustify': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 6l16 0"></path>
        <path d="M4 12l16 0"></path>
        <path d="M4 18l16 0"></path>
    `,
    'TextLetterSpacing': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 12v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"></path>
        <path d="M13 4l3 8l3 -8"></path>
        <path d="M5 18h14"></path>
        <path d="M17 20l2 -2l-2 -2"></path>
        <path d="M7 16l-2 2l2 2"></path>
    `,
    'TextLineHeight': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 8l3 -3l3 3"></path>
        <path d="M3 16l3 3l3 -3"></path>
        <path d="M6 5l0 14"></path>
        <path d="M13 6l7 0"></path>
        <path d="M13 12l7 0"></path>
        <path d="M13 18l7 0"></path>
   `,
    'TextShadow': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 20l3 0"></path>
        <path d="M14 20l7 0"></path>
        <path d="M6.9 15l6.9 0"></path>
        <path d="M10.2 6.3l5.8 13.7"></path>
        <path d="M5 20l6 -16l2 0l7 16"></path>
    `,
    'TextAlignTop': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 10l0 10"></path>
        <path d="M12 10l4 4"></path>
        <path d="M12 10l-4 4"></path>
        <path d="M4 4l16 0"></path>
    `,
    'TextAlignBottom': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 20l16 0"></path>
        <path d="M12 14l0 -10"></path>
        <path d="M12 14l4 -4"></path>
        <path d="M12 14l-4 -4"></path>
    `,
    'TextAlignMiddle': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 3v6l3 -3m-6 0l3 3"></path>
        <path d="M12 21v-6l3 3m-6 0l3 -3"></path>
        <path d="M4 12l1 0"></path>
        <path d="M9 12l1 0"></path>
        <path d="M14 12l1 0"></path>
        <path d="M19 12l1 0"></path>
    `,
    'SVGArrowLeft': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 12l14 0"></path>
        <path d="M5 12l4 4"></path>
        <path d="M5 12l4 -4"></path>
    `,
    'SVGTriangle': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M10.24 20.043l-8.422 -14.06a1.989 1.989 0 0 1 1.7 -2.983h16.845a1.989 1.989 0 0 1 1.7 2.983l-8.422 14.06a1.989 1.989 0 0 1 -3.4 0z"></path>
    `,
    'SVGCirlce': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7 3.34a10 10 0 1 1 -4.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 4.995 -8.336z" stroke-width="0" fill="currentColor"></path>
    `,
    'SVGChevronLeft': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M15 6l-6 6l6 6"></path>
    `,
    'SVGChevronRight': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 6l6 6l-6 6"></path>
    `,
    'SVGNone': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 12l14 0"></path>
    `,
    'SVGArrowRight': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 12l14 0"></path>
        <path d="M15 16l4 -4"></path>
        <path d="M15 8l4 4"></path>
    `,
    'SVGCircleRight': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7 3.34a10 10 0 1 1 -4.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 4.995 -8.336z" stroke-width="0" fill="currentColor"></path>
    `,
    'SVGCircleLeft': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7 3.34a10 10 0 1 1 -4.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 4.995 -8.336z" stroke-width="0" fill="currentColor"></path>
    `,
    'SVGStrokeRound': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
    `,
    'SVGStrokeSquare': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>
    `,
    'BoxShadow': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
        <path d="M13 12h5"></path>
        <path d="M13 15h4"></path>
        <path d="M13 18h1"></path>
        <path d="M13 9h4"></path>
        <path d="M13 6h1"></path>
    `,
    'BoxShadowNone': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5.634 5.638a9 9 0 0 0 12.728 12.727m1.68 -2.32a9 9 0 0 0 -12.086 -12.088"></path>
        <path d="M16 12h2"></path>
        <path d="M13 15h2"></path>
        <path d="M13 18h1"></path>
        <path d="M13 9h4"></path>
        <path d="M13 6h1"></path>
        <path d="M3 3l18 18"></path>
    `,
    'Blur': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M8.56 3.69a9 9 0 0 0 -2.92 1.95"></path>
        <path d="M3.69 8.56a9 9 0 0 0 -.69 3.44"></path>
        <path d="M3.69 15.44a9 9 0 0 0 1.95 2.92"></path>
        <path d="M8.56 20.31a9 9 0 0 0 3.44 .69"></path>
        <path d="M15.44 20.31a9 9 0 0 0 2.92 -1.95"></path>
        <path d="M20.31 15.44a9 9 0 0 0 .69 -3.44"></path>
        <path d="M20.31 8.56a9 9 0 0 0 -1.95 -2.92"></path>
        <path d="M15.44 3.69a9 9 0 0 0 -3.44 -.69"></path>
        <path d="M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
    `,
    'BlurNone': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M8.56 3.69a9 9 0 0 0 -.577 .263"></path>
        <path d="M3.69 8.56a9 9 0 0 0 -.69 3.44"></path>
        <path d="M3.69 15.44a9 9 0 0 0 1.95 2.92"></path>
        <path d="M8.56 20.31a9 9 0 0 0 3.44 .69"></path>
        <path d="M15.44 20.31a9 9 0 0 0 2.92 -1.95"></path>
        <path d="M20.31 15.44a9 9 0 0 0 .69 -3.44"></path>
        <path d="M20.31 8.56a9 9 0 0 0 -1.95 -2.92"></path>
        <path d="M15.44 3.69a9 9 0 0 0 -3.44 -.69"></path>
        <path d="M10.57 10.602a2 2 0 0 0 2.862 2.795"></path>
        <path d="M3 3l18 18"></path>
    `,
    'BorderRadius': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 12v-4a4 4 0 0 1 4 -4h4"></path>
        <path d="M16 4l0 .01"></path>
        <path d="M20 4l0 .01"></path>
        <path d="M20 8l0 .01"></path>
        <path d="M20 12l0 .01"></path>
        <path d="M4 16l0 .01"></path>
        <path d="M20 16l0 .01"></path>
        <path d="M4 20l0 .01"></path>
        <path d="M8 20l0 .01"></path>
        <path d="M12 20l0 .01"></path>
        <path d="M16 20l0 .01"></path>
        <path d="M20 20l0 .01"></path>
    `,
    'Copy': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"></path>
        <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"></path>
    `,
    'Paste': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h3m9 -9v-5a2 2 0 0 0 -2 -2h-2"></path>
        <path d="M13 17v-1a1 1 0 0 1 1 -1h1m3 0h1a1 1 0 0 1 1 1v1m0 3v1a1 1 0 0 1 -1 1h-1m-3 0h-1a1 1 0 0 1 -1 -1v-1"></path>
        <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
    `,
    'Delete': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 7h16"></path>
        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
        <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
        <path d="M10 12l4 4m0 -4l-4 4"></path>
    `,
    'DeleteX': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M18 6l-12 12"></path>
        <path d="M6 6l12 12"></path>
    `,
    'CopyStyle': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"></path>
        <path d="M19 6h1a2 2 0 0 1 2 2a5 5 0 0 1 -5 5l-5 0v2"></path>
        <path d="M10 15m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"></path>
   `,
    'Undo': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 14l-4 -4l4 -4"></path>
        <path d="M5 10h11a4 4 0 1 1 0 8h-1"></path>
    `,
    'Redo': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M15 14l4 -4l-4 -4"></path>
        <path d="M19 10h-11a4 4 0 1 0 0 8h1"></path>
    `,
    'ColorPicker': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M11 7l6 6"></path>
        <path d="M4 16l11.7 -11.7a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-11.7 11.7h-4v-4z"></path>
    `,
    'Visible': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
        <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path>
    `,
    'Hidden': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M10.585 10.587a2 2 0 0 0 2.829 2.828"></path>
        <path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87"></path>
        <path d="M3 3l18 18"></path>
    `,
    'DotMenu': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
    `,
    'Link': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 15l6 -6"></path>
        <path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464"></path>
        <path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463"></path>
    `,
    'LinkOff': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 15l3 -3m2 -2l1 -1"></path>
        <path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464"></path>
        <path d="M3 3l18 18"></path>
        <path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463"></path>
    `,
    'Image': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M15 8h.01"></path>
        <path d="M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z"></path>
        <path d="M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5"></path>
        <path d="M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3"></path>
    `,
    'Download': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4"></path>
        <path d="M12 13l0 9"></path>
        <path d="M9 19l3 3l3 -3"></path>
    `,
    'Code': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7 8l-4 4l4 4"></path>
        <path d="M17 8l4 4l-4 4"></path>
        <path d="M14 4l-4 16"></path>
    `,
    'CSS': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M14 3v4a1 1 0 0 0 1 1h4" />
        <path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4" />
        <path d="M8 16.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0" />
        <path d="M11 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75" /><path d="M17 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75" />
    `,
    'MasterScreen': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 16m0 1a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1z"></path>
        <path d="M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6"></path>
        <path d="M12 8h4v4"></path>
        <path d="M16 8l-5 5"></path>
    `,
    'Color': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 21a9 9 0 0 1 0 -18c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828c-.844 .75 -1.989 1.172 -3.182 1.172h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25"></path>
        <path d="M8.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M12.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M16.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
    `,
    'ColorTrans': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M15 15h-1a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25a9 9 0 0 1 -6.372 -15.356"></path>
        <path d="M8 4c1.236 -.623 2.569 -1 4 -1c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828a4.516 4.516 0 0 1 -1.127 .73"></path>
        <path d="M8.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M12.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M16.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M3 3l18 18"></path>
    `,
    'Close': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M18 6l-12 12"></path>
        <path d="M6 6l12 12"></path>
    `,
    'EventClick': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 12l3 0"></path>
        <path d="M12 3l0 3"></path>
        <path d="M7.8 7.8l-2.2 -2.2"></path>
        <path d="M16.2 7.8l2.2 -2.2"></path>
        <path d="M7.8 16.2l-2.2 2.2"></path>
        <path d="M12 12l9 3l-4 2l-2 4l-3 -9"></path>
    `,
    'EventData': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"></path>
        <path d="M4 6v6c0 1.657 3.582 3 8 3c.478 0 .947 -.016 1.402 -.046"></path>
        <path d="M20 12v-6"></path>
        <path d="M4 12v6c0 1.526 3.04 2.786 6.972 2.975"></path>
        <path d="M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"></path>
    `,
    'EventHover': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7.904 17.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l4.907 4.907a1.067 1.067 0 0 0 1.509 0l1.047 -1.047a1.067 1.067 0 0 0 0 -1.509l-4.907 -4.907l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563z"></path>
    `,
    'EventSwipeDown': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 8v13"></path>
        <path d="M15 18l-3 3l-3 -3"></path>
        <path d="M14.5 5.5l-2.5 -2.5l-2.5 2.5l2.5 2.5z"></path>
    `,
    'EventSwipeUp': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 16v-13"></path>
        <path d="M15 6l-3 -3l-3 3"></path>
        <path d="M14.5 18.5l-2.5 2.5l-2.5 -2.5l2.5 -2.5z"></path>
    `,
    'EventSwipeLeft': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M16 12h-13"></path>
        <path d="M6 9l-3 3l3 3"></path>
        <path d="M18.5 9.5l2.5 2.5l-2.5 2.5l-2.5 -2.5z"></path>
    `,
    'EventSwipeRight': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M8 12h13"></path>
        <path d="M18 9l3 3l-3 3"></path>
        <path d="M5.5 9.5l-2.5 2.5l2.5 2.5l2.5 -2.5z"></path>
    `,
    'Scroll': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"></path>
        <path d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"></path>
        <path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5"></path>
        <path d="M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"></path>
    `,
    'EventTimer': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
        <path d="M12 12l3 2"></path>
        <path d="M12 7v5"></path>
    `,
    'EventLoaded': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 4.55a8 8 0 0 1 6 14.9m0 -4.45v5h5"></path>
        <path d="M5.63 7.16l0 .01"></path>
        <path d="M4.06 11l0 .01"></path>
        <path d="M4.63 15.1l0 .01"></path>
        <path d="M7.16 18.37l0 .01"></path>
        <path d="M11 19.94l0 .01"></path>
    `,
    'Animation': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"></path>
        <path d="M3 6m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"></path>
    `,
    'NavigateBack': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 14l-4 -4l4 -4"></path>
        <path d="M5 10h11a4 4 0 1 1 0 8h-1"></path>
    `,
    'Navigation': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M17 3l0 8.707"></path>
        <path d="M13 7l4 -4l4 4"></path>
        <path d="M7 14l-4 -4l4 -4"></path>
        <path d="M17 21a11 11 0 0 0 -11 -11h-3"></path>
    `,
    'TableBorderAll': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path>
        <path d="M4 12l16 0"></path>
        <path d="M12 4l0 16"></path>
    `,
    'TableBorderBottom': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M20 20l-16 0"></path>
        <path d="M4 4l0 .01"></path>
        <path d="M8 4l0 .01"></path>
        <path d="M12 4l0 .01"></path>
        <path d="M16 4l0 .01"></path>
        <path d="M20 4l0 .01"></path>
        <path d="M4 8l0 .01"></path>
        <path d="M12 8l0 .01"></path>
        <path d="M20 8l0 .01"></path>
        <path d="M4 12l0 .01"></path>
        <path d="M8 12l0 .01"></path>
        <path d="M12 12l0 .01"></path>
        <path d="M16 12l0 .01"></path>
        <path d="M20 12l0 .01"></path>
        <path d="M4 16l0 .01"></path>
        <path d="M12 16l0 .01"></path>
        <path d="M20 16l0 .01"></path>
    `,
    'TableBorderVer': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 4l0 16"></path>
        <path d="M4 4l0 .01"></path>
        <path d="M8 4l0 .01"></path>
        <path d="M16 4l0 .01"></path>
        <path d="M20 4l0 .01"></path>
        <path d="M4 8l0 .01"></path>
        <path d="M20 8l0 .01"></path>
        <path d="M4 12l0 .01"></path>
        <path d="M8 12l0 .01"></path>
        <path d="M16 12l0 .01"></path>
        <path d="M20 12l0 .01"></path>
        <path d="M4 16l0 .01"></path>
        <path d="M20 16l0 .01"></path>
        <path d="M4 20l0 .01"></path>
        <path d="M8 20l0 .01"></path>
        <path d="M16 20l0 .01"></path>
        <path d="M20 20l0 .01"></path>
    `,
    'TableBorderHor': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 12l16 0"></path>
        <path d="M4 4l0 .01"></path>
        <path d="M8 4l0 .01"></path>
        <path d="M12 4l0 .01"></path>
        <path d="M16 4l0 .01"></path>
        <path d="M20 4l0 .01"></path>
        <path d="M4 8l0 .01"></path>
        <path d="M12 8l0 .01"></path>
        <path d="M20 8l0 .01"></path>
        <path d="M4 16l0 .01"></path>
        <path d="M12 16l0 .01"></path>
        <path d="M20 16l0 .01"></path>
        <path d="M4 20l0 .01"></path>
        <path d="M8 20l0 .01"></path>
        <path d="M12 20l0 .01"></path>
        <path d="M16 20l0 .01"></path>
        <path d="M20 20l0 .01"></path>
    `,
    'TableBorderInner': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 12l16 0"></path>
        <path d="M12 4l0 16"></path>
        <path d="M4 4l0 .01"></path>
        <path d="M8 4l0 .01"></path>
        <path d="M16 4l0 .01"></path>
        <path d="M20 4l0 .01"></path>
        <path d="M4 8l0 .01"></path>
        <path d="M20 8l0 .01"></path>
        <path d="M4 16l0 .01"></path>
        <path d="M20 16l0 .01"></path>
        <path d="M4 20l0 .01"></path>
        <path d="M8 20l0 .01"></path>
        <path d="M16 20l0 .01"></path>
        <path d="M20 20l0 .01"></path>
    `,
    'TableBorderNone': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4l0 .01"></path>
        <path d="M8 4l0 .01"></path>
        <path d="M12 4l0 .01"></path>
        <path d="M16 4l0 .01"></path>
        <path d="M20 4l0 .01"></path>
        <path d="M4 8l0 .01"></path>
        <path d="M12 8l0 .01"></path>
        <path d="M20 8l0 .01"></path>
        <path d="M4 12l0 .01"></path>
        <path d="M8 12l0 .01"></path>
        <path d="M12 12l0 .01"></path>
        <path d="M16 12l0 .01"></path>
        <path d="M20 12l0 .01"></path>
        <path d="M4 16l0 .01"></path>
        <path d="M12 16l0 .01"></path>
        <path d="M20 16l0 .01"></path>
        <path d="M4 20l0 .01"></path>
        <path d="M8 20l0 .01"></path>
        <path d="M12 20l0 .01"></path>
        <path d="M16 20l0 .01"></path>
        <path d="M20 20l0 .01"></path>
    `,
    'TableBorderOuter': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path>
        <path d="M12 8l0 .01"></path>
        <path d="M8 12l0 .01"></path>
        <path d="M12 12l0 .01"></path>
        <path d="M16 12l0 .01"></path>
        <path d="M12 16l0 .01"></path>
    `,
    'TableBorderTop': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4l16 0"></path>
        <path d="M4 8l0 .01"></path>
        <path d="M12 8l0 .01"></path>
        <path d="M20 8l0 .01"></path>
        <path d="M4 12l0 .01"></path>
        <path d="M8 12l0 .01"></path>
        <path d="M12 12l0 .01"></path>
        <path d="M16 12l0 .01"></path>
        <path d="M20 12l0 .01"></path>
        <path d="M4 16l0 .01"></path>
        <path d="M12 16l0 .01"></path>
        <path d="M20 16l0 .01"></path>
        <path d="M4 20l0 .01"></path>
        <path d="M8 20l0 .01"></path>
        <path d="M12 20l0 .01"></path>
        <path d="M16 20l0 .01"></path>
        <path d="M20 20l0 .01"></path>
    `,
    'TableData': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7"></path>
        <path d="M3 10h18"></path>
        <path d="M10 3v18"></path>
        <path d="M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
        <path d="M19.001 15.5v1.5"></path>
        <path d="M19.001 21v1.5"></path>
        <path d="M22.032 17.25l-1.299 .75"></path>
        <path d="M17.27 20l-1.3 .75"></path>
        <path d="M15.97 17.25l1.3 .75"></path>
        <path d="M20.733 20l1.3 .75"></path>
    `,
    'TableHeader': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path>
        <path d="M4 9l16 0"></path>
    `,
    'EditPencil': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path>
        <path d="M13.5 6.5l4 4"></path>
    `,
    'EditSquare': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"></path>
        <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"></path>
        <path d="M16 5l3 3"></path>
    `,
    'EditScroll': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"></path>
        <path d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"></path>
        <path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5"></path>
        <path d="M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"></path>
    `,
    'EditMove': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"></path>
        <path d="M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5"></path>
        <path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5"></path>
        <path d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"></path>
    `,
    'DataBinding': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0 -16 0"></path>
        <path d="M4 6v6a8 3 0 0 0 16 0v-6"></path>
        <path d="M4 12v6a8 3 0 0 0 16 0v-6"></path>  
    `,
    'DataBindingPlus': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"></path>
        <path d="M4 6v6c0 1.657 3.582 3 8 3c1.075 0 2.1 -.08 3.037 -.224"></path>
        <path d="M20 12v-6"></path>
        <path d="M4 12v6c0 1.657 3.582 3 8 3c.166 0 .331 -.002 .495 -.006"></path>
        <path d="M16 19h6"></path>
        <path d="M19 16v6"></path>
    `,
    'CheckBoxRound': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" stroke-width="0" fill="currentColor" />
    `,
    'CheckBoxHook': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M5 12l5 5l10 -10" />
    `,
    'CheckBoxOn': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>
        <path d="M9 12l2 2l4 -4"></path>
    `,
    'CheckBoxOff': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>
    `,
    'Upload': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
        <path d="M7 9l5 -5l5 5"></path>
        <path d="M12 4l0 12"></path>
    `,
    'UploadCloud': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"></path>
        <path d="M9 15l3 -3l3 3"></path>
        <path d="M12 12l0 9"></path>
    `,
    'AnimationLeft': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"></path>
        <path d="M20 18h-17"></path>
        <path d="M6 15l-3 3l3 3"></path>
    `,
    'AnimationRight': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M20 12v-6a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v8"></path>
        <path d="M4 18h17"></path>
        <path d="M18 15l3 3l-3 3"></path>
    `,
    'AnimationUp': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 4h-6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8"></path>
        <path d="M18 20v-17"></path>
        <path d="M15 6l3 -3l3 3"></path>
    `,
    'AnimationDown': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8"></path>
        <path d="M18 4v17"></path>
        <path d="M15 18l3 3l3 -3"></path>
    `,
    'AnimationTransform': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M6 21l15 -15l-3 -3l-15 15l3 3"></path>
        <path d="M15 6l3 3"></path>
        <path d="M9 3a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"></path>
        <path d="M19 13a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"></path>
    `,
    'AnimationScroll': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 11v8l3 -3m-6 0l3 3" />
        <path d="M9 7l1 0" />
        <path d="M14 7l1 0" />
        <path d="M19 7l1 0" />
        <path d="M4 7l1 0" />
    `,
    'AnimationFadeIn': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 21a9.01 9.01 0 0 0 2.32 -.302a9 9 0 0 0 1.74 -16.733a9 9 0 1 0 -4.06 17.035z"></path>
        <path d="M12 3v17"></path>
        <path d="M12 12h9"></path>
        <path d="M12 9h8"></path>
        <path d="M12 6h6"></path>
        <path d="M12 18h6"></path>
        <path d="M12 15h8"></path>
    `,
    'AnimationFadeOut': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 3v5m0 4v8"></path>
        <path d="M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"></path>
        <path d="M16 12h5"></path>
        <path d="M13 9h7"></path>
        <path d="M12 6h6"></path>
        <path d="M12 18h6"></path>
        <path d="M12 15h3m4 0h1"></path>
        <path d="M3 3l18 18"></path>
    `,
    'AnimationZoom': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M16 4l4 0l0 4"></path>
        <path d="M14 10l6 -6"></path>
        <path d="M8 20l-4 0l0 -4"></path>
        <path d="M4 20l6 -6"></path>
        <path d="M16 20l4 0l0 -4"></path>
        <path d="M14 14l6 6"></path>
        <path d="M8 4l-4 0l0 4"></path>
        <path d="M4 4l6 6"></path>
    `,
    'AnimationDuration': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
        <path d="M12 12l3 2"></path>
        <path d="M12 7v5"></path>
    `,
    'AnimationEasing': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M17 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0z"></path>
        <path d="M17 20h-2"></path>
        <path d="M7 4a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z"></path>
        <path d="M7 4h2"></path>
        <path d="M14 4h-2"></path>
        <path d="M12 20h-2"></path>
        <path d="M3 20c8 0 10 -16 18 -16"></path>
    `,
    'AnimationRotate': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 4.55a8 8 0 0 1 6 14.9m0 -4.45v5h5"></path>
        <path d="M5.63 7.16l0 .01"></path>
        <path d="M4.06 11l0 .01"></path>
        <path d="M4.63 15.1l0 .01"></path>
        <path d="M7.16 18.37l0 .01"></path>
        <path d="M11 19.94l0 .01"></path>
    `,
    'AnimationGrowRight': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 9l3 3l-3 3"></path>
        <path d="M13 9l3 3l-3 3"></path>
        <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"></path>
    `,
    'AniamtionGrowLeft': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M15 15l-3 -3l3 -3"></path>
        <path d="M11 15l-3 -3l3 -3"></path>
        <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"></path>
    `,
    'AnimationGrowDown': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M15 9l-3 3l-3 -3"></path>
        <path d="M15 13l-3 3l-3 -3"></path>
        <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"></path>
    `,
    'AnimationGrowUp': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 15l3 -3l3 3"></path>
        <path d="M9 11l3 -3l3 3"></path>
        <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"></path>
    `,
    'HandleDND': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M9 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M9 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M15 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M15 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
        <path d="M15 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
    `,
    'ScreenSegment': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 16m0 1a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1z"></path>
        <path d="M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6"></path>
        <path d="M15 13h-4v-4"></path>
        <path d="M11 13l5 -5"></path>
    `,
    'DataTable': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z"></path>
        <path d="M3 10h18"></path>
        <path d="M10 3v18"></path>
    `,
    'ImageFilter': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M13.58 13.79c.27 .68 .42 1.43 .42 2.21c0 1.77 -.77 3.37 -2 4.46a5.93 5.93 0 0 1 -4 1.54c-3.31 0 -6 -2.69 -6 -6c0 -2.76 1.88 -5.1 4.42 -5.79"></path>
        <path d="M17.58 10.21c2.54 .69 4.42 3.03 4.42 5.79c0 3.31 -2.69 6 -6 6a5.93 5.93 0 0 1 -4 -1.54"></path>
        <path d="M12 8m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"></path>
    `,
    'ImageCrop': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M8 5v10a1 1 0 0 0 1 1h10"></path>
        <path d="M5 8h10a1 1 0 0 1 1 1v10"></path>
    `,
    'ImageList': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M15 6l.01 0"></path>
        <path d="M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"></path>
        <path d="M3 13l4 -4a3 5 0 0 1 3 0l4 4"></path>
        <path d="M13 12l2 -2a3 5 0 0 1 3 0l3 3"></path>
        <path d="M8 21l.01 0"></path>
        <path d="M12 21l.01 0"></path>
        <path d="M16 21l.01 0"></path>
    `,
    'LetterLower': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M6.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"></path>
        <path d="M10 12v7"></path>
        <path d="M17.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"></path>
        <path d="M21 12v7"></path>
    `,
    'LetterUpper': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"></path>
        <path d="M3 13h7"></path>
        <path d="M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"></path>
        <path d="M14 13h7"></path>
    `,
    'LetterNormal': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M17.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"></path>
        <path d="M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"></path>
        <path d="M3 13h7"></path>
        <path d="M21 12v7"></path>
    `,
    'ScrollVertical': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h6"></path>
        <path d="M18 14v7"></path>
        <path d="M18 3v7"></path>
        <path d="M15 18l3 3l3 -3"></path>
        <path d="M15 6l3 -3l3 3"></path>
    `,
    'ScrollHorizontal': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"></path>
        <path d="M10 18h-7"></path>
        <path d="M21 18h-7"></path>
        <path d="M6 15l-3 3l3 3"></path>
        <path d="M18 15l3 3l-3 3"></path>
    `,
    'Reference': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 4h6a2 2 0 0 1 2 2v14l-5 -3l-5 3v-14a2 2 0 0 1 2 -2"></path>
    `,
    'ReferenceNone': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 3l18 18"></path>
        <path d="M17 17v3l-5 -3l-5 3v-13m1.178 -2.818c.252 -.113 .53 -.176 .822 -.176h6a2 2 0 0 1 2 2v7"></path>
    `,
    'User': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
        <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
    `,
    'Chart': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 3v18h18"></path>
        <path d="M20 18v3"></path>
        <path d="M16 16v5"></path>
        <path d="M12 13v8"></path>
        <path d="M8 16v5"></path>
        <path d="M3 11c6 0 5 -5 9 -5s3 5 9 5"></path>
    `,
   'ChartBubble': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M6 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
        <path d="M16 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
        <path d="M14.5 7.5m-4.5 0a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0 -9 0"></path>
    `,
    'Analyze': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
        <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
        <path d="M9 17h6"></path>
        <path d="M9 13h6"></path>
    `,
    'AnalzyeDots': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
        <path d="M16 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
        <path d="M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
        <path d="M6 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
        <path d="M9 17l5 -1.5"></path>
        <path d="M6.5 8.5l7.81 5.37"></path>
        <path d="M7 7l8 -1"></path>
    `,
    'AnalyseChart': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
        <path d="M9 8m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
        <path d="M15 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
        <path d="M4 20l14 0"></path>
    `,
    'Calender': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path>
        <path d="M16 3l0 4"></path>
        <path d="M8 3l0 4"></path>
        <path d="M4 11l16 0"></path>
        <path d="M8 15h2v2h-2z"></path>
    `,
    'Count': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 9l14 0"></path>
        <path d="M5 15l14 0"></path>
        <path d="M11 4l-4 16"></path>
        <path d="M17 4l-4 16"></path>
    `,
    'Clock': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
        <path d="M12 12l3 2"></path>
        <path d="M12 7v5"></path>
    `,
    'World': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
        <path d="M3.6 9h16.8"></path>
        <path d="M3.6 15h16.8"></path>
        <path d="M11.5 3a17 17 0 0 0 0 18"></path>
        <path d="M12.5 3a17 17 0 0 1 0 18"></path>
    `,
    'Search': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
        <path d="M21 21l-6 -6"></path>
    `,
    'SortableListUp': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 5l0 14"></path>
        <path d="M16 9l-4 -4"></path>
        <path d="M8 9l4 -4"></path>
    `,
    'SortableListDown': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 5l0 14"></path>
        <path d="M16 15l-4 4"></path>
        <path d="M8 15l4 4"></path>
    `,
    'ResiseGrid': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M18 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
        <path d="M6 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
        <path d="M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
        <path d="M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
        <path d="M8 18h8"></path>
        <path d="M18 20v1"></path>
        <path d="M18 3v1"></path>
        <path d="M6 20v1"></path>
        <path d="M6 10v-7"></path>
        <path d="M12 3v18"></path>
        <path d="M18 8v8"></path>
        <path d="M8 12h13"></path>
        <path d="M21 6h-1"></path>
        <path d="M16 6h-13"></path>
        <path d="M3 12h1"></path>
        <path d="M20 18h1"></path>
        <path d="M3 18h1"></path>
        <path d="M6 14v2"></path>
    `,
    'ResiseGrid2': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path>
        <path d="M4 9h8"></path>
        <path d="M12 15h8"></path>
        <path d="M12 4v16"></path>
    `,
    'DeleteTrash': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 7l16 0"></path>
        <path d="M10 11l0 6"></path>
        <path d="M14 11l0 6"></path>
        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
        <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
    `,
    'AVG': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 21l18 -18"></path>
        <path d="M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0"></path>
    `,
    'Book': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0"></path>
        <path d="M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0"></path>
        <path d="M3 6l0 13"></path>
        <path d="M12 6l0 13"></path>
        <path d="M21 6l0 13"></path>
    `,
    'Account': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
        <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
    `,
    'Logout': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"></path>
        <path d="M9 12h12l-3 -3"></path>
        <path d="M18 15l3 -3"></path>
    `,
    'UserPlus': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
        <path d="M16 19h6"></path>
        <path d="M19 16v6"></path>
        <path d="M6 21v-2a4 4 0 0 1 4 -4h4"></path>
    `,
    'Heatmap' : `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 12c2 -2.96 0 -7 -1 -8c0 3.038 -1.773 4.741 -3 6c-1.226 1.26 -2 3.24 -2 5a6 6 0 1 0 12 0c0 -1.532 -1.056 -3.94 -2 -5c-1.786 3 -2.791 3 -4 2z"></path>
    `,
    'Design': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path>
        <path d="M13.5 6.5l4 4"></path>
    `,
    'Share': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M13 4v4c-6.575 1.028 -9.02 6.788 -10 12c-.037 .206 5.384 -5.962 10 -6v4l8 -7l-8 -7z"></path>
    `,
    'Projects': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
        <path d="M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
        <path d="M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
        <path d="M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
    `,
    'Dots': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
        <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
        <path d="M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    `,
    'EventKeykoard': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 3a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3" />
        <path d="M6 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3" />
        <path d="M13 7h7a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-7" />
        <path d="M5 7h-1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h1" />
        <path d="M17 12h.01" />
        <path d="M13 12h.01" />
    `,
    'Notification': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" />
        <path d="M9 17v1a3 3 0 0 0 6 0v-1" />
    `,
    'NotificationAll': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 8l0 4l2 2" />
        <path d="M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5" />
    `,
    'Mail': `
        <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" />
        <path d="M3 7l9 6l9 -6" /><
    `,
    'Key': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M16.555 3.843l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.643 2.643a2.877 2.877 0 0 1 -4.069 0l-.301 -.301l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.877 2.877 0 0 1 0 -4.069l2.643 -2.643a2.877 2.877 0 0 1 4.069 0z" />
        <path d="M15 9h.01" />
    `,
    'LockClosed': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z" />
        <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" />
        <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
    `,
    'LockOpen': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M5 11m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z" />
        <path d="M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
        <path d="M8 11v-5a4 4 0 0 1 8 0" />
    `,
    'ChevronDown': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M6 9l6 6l6 -6" />
    `,
    'ChevronRight': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M9 6l6 6l-6 6" />\
    `,
    'Padding': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
        <path d="M8 16v.01" />
        <path d="M8 12v.01" />
        <path d="M8 8v.01" />
        <path d="M16 16v.01" />
        <path d="M16 12v.01" />
        <path d="M16 8v.01" />
        <path d="M12 8v.01" />
        <path d="M12 16v.01" />
    `,
    'BorderSides': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M4 8v8" />
        <path d="M20 16v-8" />
        <path d="M8 4h8" />
        <path d="M8 20h8" />
    `,
    'BorderStyle': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M4 18v.01" />
        <path d="M8 18v.01" />
        <path d="M12 18v.01" />
        <path d="M16 18v.01" />
        <path d="M20 18v.01" />
        <path d="M18 12h2" />
        <path d="M11 12h2" />
        <path d="M4 12h2" />
        <path d="M4 6h16" />
    `,
    'BorderOuter': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
        <path d="M12 8l0 .01" />
        <path d="M8 12l0 .01" />
        <path d="M12 12l0 .01" />
        <path d="M16 12l0 .01" />
        <path d="M12 16l0 .01" />
    `,
    'CalendarTime': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M10.5 21h-4.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3" />
        <path d="M16 3v4" />
        <path d="M8 3v4" />
        <path d="M4 11h10" />
        <path d="M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" /
        ><path d="M18 16.5v1.5l.5 .5" />
    `,
    'Calendar': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" />
        <path d="M16 3v4" />
        <path d="M8 3v4" />
        <path d="M4 11h16" />
        <path d="M11 15h1" />
        <path d="M12 15v3" />
    `,
    'Duration': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M9 9v6" />
        <path d="M12 11v2a2 2 0 1 0 4 0v-2a2 2 0 1 0 -4 0z" />
        <path d="M3 12v.01" />
        <path d="M21 12v.01" />
        <path d="M12 21v.01" />
        <path d="M7.5 4.2v.01" />
        <path d="M16.5 19.8v.01" />
        <path d="M7.5 19.8v.01" />
        <path d="M4.2 16.5v.01" />
        <path d="M19.8 16.5v.01" />
        <path d="M4.2 7.5v.01" />
        <path d="M19.81 7.527a8.994 8.994 0 0 0 -7.81 -4.527" />
    `,
    'Hash': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M5 9l14 0" />
        <path d="M5 15l14 0" />
        <path d="M11 4l-4 16" />
        <path d="M17 4l-4 16" />
    `,
    'Outlier': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
        <path d="M6 21v-2a4 4 0 0 1 4 -4h3.5" />
        <path d="M19 22v.01" />
        <path d="M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483" />
    `,
    'Duplicate': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2" />
        <path d="M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
        <path d="M14 4l0 4l-6 0l0 -4" />
    `,
    'Tests': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
        <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
        <path d="M9 12l.01 0" />
        <path d="M13 12l2 0" />
        <path d="M9 16l.01 0" />
        <path d="M13 16l2 0" />
    `,
    'Results': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M4 19l16 0" />
        <path d="M4 15l4 -6l4 2l4 -5l4 4" />
    `,
    'Overview': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
        <path d="M9 4l0 16" />
    `,
    'SingleSelect': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M5 12l5 5l10 -10" />
    `,
    'MultiSelect': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M7 12l5 5l10 -10" />
        <path d="M2 12l5 5m5 -5l5 -5" />
    `,
    'Audio': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
        <path d="M13 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
        <path d="M9 17v-13h10v13" />
        <path d="M9 8h10" />
    `,
    'AudioPlus': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
        <path d="M9 17v-13h10v8" />
        <path d="M9 8h10" />
        <path d="M16 19h6" />
        <path d="M19 16v6" />
    `,
    'ArrowsHor': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M7 8l-4 4l4 4" />
        <path d="M17 8l4 4l-4 4" />
        <path d="M3 12l18 0" />
    `,
    'ArrowsVer': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M8 7l4 -4l4 4" />
        <path d="M8 17l4 4l4 -4" />
        <path d="M12 3l0 18" />
    `,
    'Maximize': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 17a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1l0 -3" />
        <path d="M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6" />
        <path d="M12 8h4v4" />
        <path d="M16 8l-5 5" />
    `,
    'Minimize': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 17a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1l0 -3" />
        <path d="M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6" />
        <path d="M15 13h-4v-4" />
        <path d="M11 13l5 -5" />
    `,
    'ArrowUp': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 5l0 14" />
        <path d="M16 9l-4 -4" />
        <path d="M8 9l4 -4" />
    `, 
    'FilterBlur': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 21a9.01 9.01 0 0 0 2.32 -.302a9 9 0 0 0 1.74 -16.733a9 9 0 1 0 -4.06 17.035" />
        <path d="M12 3v17" />
        <path d="M12 12h9" />
        <path d="M12 9h8" />
        <path d="M12 6h6" />
        <path d="M12 18h6" />
        <path d="M12 15h8" />
    `,
    'FilterBlurNone': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 3v5m0 4v8" />
        <path d="M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098" />
        <path d="M16 12h5" />
        <path d="M13 9h7" />
        <path d="M12 6h6" />
        <path d="M12 18h6" />
        <path d="M12 15h3m4 0h1" />
        <path d="M3 3l18 18" />
    `,
    'Mouse': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M6 7a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-4a4 4 0 0 1 -4 -4l0 -10" />
        <path d="M12 3v7" />
        <path d="M6 10h12" />
    `,
    'TextFontSize': `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 7v-2h13v2" />
        <path d="M10 5v14" />
        <path d="M12 19h-4" />
        <path d="M15 13v-1h6v1" />
        <path d="M18 12v7" />
        <path d="M17 19h2" />
    `,
    'DesignTokenBorder' : `
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -14" />
    `
}
